import { z } from 'zod'
import { makeFieldKeys } from '../../core/utils/utilities.ts'

export const ReportingConfigModelSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    menu_item_id: z.string(),
    default: z.boolean(),
    freeze_leading_columns: z.number(),
    date_created: z.string(),
    date_modified: z.string()
  })
  .strict()

const ReportingConfigModelFields = makeFieldKeys(ReportingConfigModelSchema)

export type ReportingConfigModel = z.infer<typeof ReportingConfigModelSchema>
